export default class MonitoringReportV2ViewModel {
    //IMPLEMENTATION
    travelPlanType: string | null = null;
    travelPLanCoordinator: string | null = null;
    coordinatorShiftType: string | null = null;
    initialMonthImplemeted: number | null = null;
    initialYearImplemeted: number | null = null;
    currentMonthImplemeted: number | null = null;
    currentYearImplemeted: number | null = null;
    developerInitiativesComment: string | null = null;

    //SPLITS
    modeSplitObtainedPrior: string | null = null;
    modeSplitMonth: number | null = null;
    modeSplitYear: number | null = null;
    modeSplitVehicle: number | null = null;
    modeSplitCyclist: number | null = null;
    modeSplitTransport: number | null = null;
    modeSplitPedestrians: number | null = null;
    modeSplitSource: string | null = null;
    targetsIdentified: string | null = null;
    targetsMonth: number | null = null;
    targetsYear: number | null = null;
    targetsVehicle: number | null = null;
    targetsCyclist: number | null = null;
    targetsTransport: number | null = null;
    targetsPedestrians: number | null = null;
    targetsYearOfLife: number | null = null;
    targetGroupStaff: string | null = null;
    targetGroupVisitors: string | null = null;
    targetGroupCustomers: string | null = null;
    targetGroupStudents: string | null = null;
    targetGroupPatients: string | null = null;
    targetGroupAllSiteUsers: string | null = null;
    targetGroupOther: string | null = null;
    targetGroupOtherText: string | null = null;
    mainObjectiveComments: string | null = null;
    individualComments: string | null = null;

    //SITE DETAILS
    description: string | null = null;
    street: string | null = null;
    district: string | null = null;
    town: string | null = null;
    postalCode: string | null = null;
    location: string | null = null;
    subCategory: string | null = null;
    latitude: number | null = null;
    longitude: number | null = null;
    developmentName: string | null = null;
    totPar1: number | null = null;
    totPar1Unit: string | null = null;
    totPar1abbreviation: string | null = null;
    totPar2: number | null = null;
    totPar2abbreviation: string | null = null;
    detachedPrivate: number | null = null;
    detachedNonPrivate: number | null = null;
    detachedTotal: number | null = null;
    semiDetachedPrivate: number | null = null;
    semiDetachedNonPrivate: number | null = null;
    semiDetachedTotal: number | null = null;
    terracedPrivate: number | null = null;
    terracedNonPrivate: number | null = null;
    terracedTotal: number | null = null;
    bungalowPrivate: number | null = null;
    bungalowNonPrivate: number | null = null;
    bungalowTotal: number | null = null;
    flatHousePrivate: number | null = null;
    flatHouseNonPrivate: number | null = null;
    flatHouseTotal: number | null = null;
    flatBlockPrivate: number | null = null;
    flatBlockNonPrivate: number | null = null;
    flatBlockTotal: number | null = null;
    townhousePrivate: number | null = null;
    townhouseNonPrivate: number | null = null;
    townhouseTotal: number | null = null;
    residentialUnitsOther: string | null = null;
    residentialUnitsAveragePerUnit: number | null = null;
    openSince: number | null = null;
    parkingTotal: number | null = null;
    parkingOnStreet: number | null = null;
    parkingDriveways: number | null = null;
    parkingGarage: number | null = null;
    parkingCommunal: number | null = null;
    parkingAllocated: number | null = null;
    parkingElectric: number | null = null;
    changesFromPrevious: string | null = null;

    //FEATURES
    // Cycling
    cycleSheds: string | null = null;
    cycleShedsMonth: number | null = null;
    cycleShedsYear: number | null = null;
    coveredCompound: string | null = null;
    coveredCompoundMonth: number | null = null;
    coveredCompoundYear: number | null = null;
    securityFeatures: string | null = null;
    securityFeaturesMonth: number | null = null;
    securityFeaturesYear: number | null = null;
    cycleRoutes: string | null = null;
    cycleRoutesMonth: number | null = null;
    cycleRoutesYear: number | null = null;
    cyclingInPlacePrior: string | null = null;
    cycleComment: string | null = null;

    // Incentives
    seasonLoan: string | null = null;
    seasonLoanMonth: number | null = null;
    seasonLoanYear: number | null = null;
    cycleIncentive: string | null = null;
    cycleIncentiveMonth: number | null = null;
    cycleIncentiveYear: number | null = null;
    travelVoucher: string | null = null;
    travelVoucherMonth: number | null = null;
    travelVoucherYear: number | null = null;
    busOrSeasonTicket: string | null = null;
    busOrSeasonTicketValue: number | null = null;
    trainOrSeasonTicket: string | null = null;
    trainOrSeasonTicketValue: number | null = null;
    purchaseOfCycleEquipment: string | null = null;
    purchaseOfCycleEquipmentValue: number | null = null;
    cycleTraining: string | null = null;
    cycleTrainingValue: number | null = null;
    otherIncentive: string | null = null;
    otherIncentiveText: string | null = null;
    otherIncentiveValue: number | null = null;
    incentiveComment: string | null = null;

    //  Transport
    bus400m: string | null = null;
    realTimeInformation: string | null = null;
    timetableDisplay: string | null = null;
    shelter: string | null = null;
    seating: string | null = null;
    droppedKerbs: string | null = null;
    droppedKerbsMonth: number | null = null;
    droppedKerbsYear: number | null = null;
    droppedKerbsPrior: string | null = null;
    newBusServices: string | null = null;
    newBusServicesMonth: number | null = null;
    newBusServicesYear: number | null = null;
    newBusServicesPrior: string | null = null;
    pedestrian400m: string | null = null;
    pedestrian400mMonth: number | null = null;
    pedestrian400mYear: number | null = null;
    pedestrian400mPrior: string | null = null;
    pedestrian1000m: string | null = null;
    pedestrian1000mMonth: number | null = null;
    pedestrian1000mYear: number | null = null;
    pedestrian1000mPrior: string | null = null;
    infoProvided: string | null = null;
    welcomePack: string | null = null;
    noticeboard: string | null = null;
    wewsletters: string | null = null;
    staffInfoPacks: string | null = null;
    journeyPlanning: string | null = null;
    travelWebsite: string | null = null;
    timeTableDigitalOrPaper: string | null = null;
    transportOther: string | null = null;
    transportOtherText: string | null = null;
    transportOtherMonth: number | null = null;
    transportOtherYear: number | null = null;
    transportComment: string | null = null;

    // Car Sharing
    carClub: string | null = null;
    carClubMonth: number | null = null;
    carClubYear: number | null = null;
    carClubComments: string | null = null;

    // Car Parking
    restrictedAvailabilityParking: string | null = null;
    restrictedAvailabilityParkingMonth: number | null = null;
    restrictedAvailabilityParkingYear: number | null = null;
    restrictedAvailabilityParkingPrior: string | null = null;
    parkingRestrictions: string | null = null;
    parkingRestrictionsMonth: number | null = null;
    parkingRestrictionsYear: number | null = null;
    parkingCharges: string | null = null;
    parkingChargesMonth: number | null = null;
    parkingChargesYear: number | null = null;
    parkingMeasuresEnfored: string | null = null;
    parkingMeasuresEnforedMonth: number | null = null;
    parkingMeasuresEnforedYear: number | null = null;
    electricCharging: string | null = null;
    electricChargingMonth: number | null = null;
    electricChargingYear: number | null = null;
    electricChargingCount: number | null = null;
    electricChargingPrior: string | null = null;
    carParkingComments: string | null = null;
    // Shuttle Bus
    shuttleBusResidentail: string | null = null;
    shuttleBusResidentailMonth: number | null = null;
    shuttleBusResidentailYear: number | null = null;
    shuttleBusRail: string | null = null;
    shuttleBusRailMonth: number | null = null;
    shuttleBusRailYear: number | null = null;
    shuttleBusComment: string | null = null;
    //Marketing
    marketingSuite: string | null = null;
    marketingSuiteIncludeTravelPlan: string | null = null;
    marketingSuiteIncludeTravelPlanMonth: number | null = null;
    marketingSuiteIncludeTravelPlanYear: number | null = null;
    marketingTraining: string | null = null;
    marketingTrainingMonth: number | null = null;
    marketingTrainingYear: number | null = null;
    marketingComments: string | null = null;
}